import * as types from "../../constants";
import { Property } from "../../models/Property";
import * as actions from "../actions-declarations/property";
import { ActionsOf, init } from "../utils";
import {PropertyAccessibilityInfo} from "../../models/PropertyAccessibilityInfo";
import {PropertyFreeTextsInfo} from "../../models/PropertyFreeTextInfos";

export type PropertyActions = typeof actions;

export type PropertyActionType = {
  property: object;
  count: number;
};

export type PropertyType = {
  property?: object | undefined;
  properties?: any;
  count?: number;
};

const defaultState = {
  properties: [],
  propertyAccessibilityInfo: null,
  propertyFreeTextInfos: null,
  totalAccessibilityProgressBar: {
    completed: null,
    notCompleted: null
  },
  loading: {
    property: true,
    properties: true
  }
}

export default function reducer(
  state = init<{
    property?: Property;
    properties: Property[];
    propertyAccessibilityInfo: PropertyAccessibilityInfo[] | null;
    propertyFreeTextInfos: PropertyFreeTextsInfo[] | null;
    count?: number;
    totalAccessibilityProgressBar: {
      completed: number | null;
      notCompleted: number | null;
    };
    loading: {
      property: boolean;
      properties: boolean;
    };
  }>(defaultState),
  actions: ActionsOf<PropertyActions>
): typeof state {
  switch (actions.type) {
    case types.PROPERTY_CREATE:
      return {
        ...state,
        property: actions.property,
      };
    case types.FETCH_PROPERTY:
      return {
        ...state,
        property: actions.property,
      };
    case types.PROPERTY_UPDATE:
      return {
        ...state,
        property: actions.property,
      };
    case types.PARTIAL_PROPERTY_UPDATE:
      return {
        ...state,
        property: actions.property,
      };
    case types.FETCH_PROPERTIES:
      return {
        ...state,
        properties: actions.properties,
      };
    case types.CLEAR_PROPERTIES:
      return {
        ...state,
        properties: [],
        loading: {
          ...state.loading,
          properties: true
        }
      }
    case types.GET_ACCESSIBILITY_UNIT_TYPES:
      return {
        ...state,
        // TODO Check here
        properties: (actions as any).property,
      };
    case types.SET_PROPERTY_COUNT:
      return {
        ...state,
        count: actions.count,
      };
    case types.CLEAR_PROPERTY:
      return {
        ...state,
        property: null!,
        loading: {
          ...state.loading,
          property: true
        }
      };
    case types.FETCH_TOTAL_ACCESSIBILITY_PROGRESS_BAR:
      return {
        ...state,
        totalAccessibilityProgressBar: actions.payload,
      };

    case types.CLEAR_TOTAL_ACCESSIBILITY_PROGRESS_BAR:
      return {
        ...state,
        totalAccessibilityProgressBar: {
          completed: null!,
          notCompleted: null!
        },
      };
    case types.LOADING_PROPERTY:
      return {
        ...state,
        loading: {
          ...state.loading,
          property: actions.payload
        }
      }
    case types.LOADING_PROPERTIES:
      return {
        ...state,
        loading: {
          ...state.loading,
          properties: actions.payload
        }
      }
    case types.FETCH_PROPERTY_ACCESSIBILITY_INFOS:
      return {
        ...state,
        propertyAccessibilityInfo: actions.payload
      }

    case types.CLEAR_PROPERTY_ACCESSIBILITY_INFOS:
      return {
        ...state,
        propertyAccessibilityInfo: null
      }
    case types.CREATE_PROPERTY_ACCESSIBILITY_INFOS:
      let newStatePropertyAccessibilityInfo = []
      if (state.propertyAccessibilityInfo) {
        newStatePropertyAccessibilityInfo = [...state.propertyAccessibilityInfo, actions.payload]
      } else {
        newStatePropertyAccessibilityInfo = [actions.payload]
      }
      return {
        ...state,
        propertyAccessibilityInfo: newStatePropertyAccessibilityInfo
      }
    case types.UPDATE_PROPERTY_ACCESSIBILITY_INFOS:
      let newPropertyAccessibilityInfo: PropertyAccessibilityInfo[] = []
      if (state.propertyAccessibilityInfo) {
        newPropertyAccessibilityInfo = state.propertyAccessibilityInfo.map((i) => {
          if (i.id === actions.payload.id) {
            i = actions.payload
          }
          return i
        })
      }
      return {
        ...state,
        propertyAccessibilityInfo: newPropertyAccessibilityInfo
      }

    case types.FETCH_PROPERTY_FREE_TEXT_INFOS:
      return {
        ...state,
        propertyFreeTextInfos: actions.payload
      }

    case types.CLEAR_PROPERTY_FREE_TEXT_INFOS:
      return {
        ...state,
        propertyFreeTextInfos: null
      }


    case types.CREATE_PROPERTY_FREE_TEXT_INFOS:
      let newState = []
      if (state.propertyFreeTextInfos) {
        newState = [...state.propertyFreeTextInfos, actions.payload]
      } else {
        newState = [actions.payload]
      }
      return {
        ...state,
        propertyFreeTextInfos: newState
      }

    case types.UPDATE_PROPERTY_FREE_TEXT_INFOS:
      let newPropertyFreetextInfos: PropertyFreeTextsInfo[] = []
      if (state.propertyFreeTextInfos) {
        newPropertyFreetextInfos = state.propertyFreeTextInfos.map((i) => {
          if (i.id === actions.payload.id) {
            i = actions.payload
          }
          return i
        })
      }
      return {
        ...state,
        propertyFreeTextInfos: newPropertyFreetextInfos
      }
    case types.DELETE_PROPERTY_FREE_TEXT_INFOS:
      let newStatePropertyFreeTextInfos: PropertyFreeTextsInfo[] = []
      if (state.propertyFreeTextInfos) {
        newStatePropertyFreeTextInfos = state.propertyFreeTextInfos
          .filter((i) => i.id !== actions.payload)
      }
      return {
        ...state,
        propertyFreeTextInfos: newStatePropertyFreeTextInfos
      }
    default:
      return { ...state };
  }
}
